export const VideoReviewButton = {
  name: "video-review-button",
  component: "TypeButton",
  layout: "match-button",
  mode: "visible",
  text: "videoReview",
  showOn: [
    {
      state: "period.periodStatus",
      value: "inProgress",
      operator: "is",
    },
    {
      state: "videoReview.start",
      value: false,
      operator: "is",
    },
  ],
  startEvent: true,
  startPlay: false,
  actionGroups: [
    {
      actions: [
        { action: "stopClock", value: "stop", type: "main" },
        { action: "newPlayId", value: null, type: "main" },
        { action: "clearData", value: ["entityId"], type: "main" },
        { action: "saveData", value: "videoReview", type: "eventType" },
        { action: "saveData", value: "start", type: "subType" },
        { action: "sendEvent", value: "new", type: "main" },
        { action: "nextState", value: null, type: "primary" },
      ],
    },
  ],
};

export const VideoReviewEndButton = {
  name: "video-review-end-button",
  component: "TypeButton",
  layout: "match-button",
  mode: "visible",
  text: "videoReview.end",
  showOn: [
    {
      state: "videoReview.start",
      value: true,
      operator: "is",
    },
  ],
  startEvent: true,
  startPlay: true,
  actionGroups: [
    {
      actions: [
        { action: "newPlayId", value: null, type: "main" },
        { action: "clearData", value: ["entityId"], type: "main" },
        { action: "saveData", value: "videoReview", type: "eventType" },
        { action: "saveData", value: "end", type: "subType" },
        { action: "sendEvent", value: "new", type: "main" },
        { action: "nextState", value: null, type: "primary" },
      ],
    },
  ],
};

export const SwitchTeamsButton = {
  name: "switch-teams",
  component: "TeamSwitch",
  layout: "match-button small",
  mode: "enable",
  sendUpdateArrow: false,
  showOn: [{ state: "clock.clockRunning", value: false, operator: "is" }],
  startEvent: false,
  startPlay: false,
};

export const TimeoutButton = {
  name: "timeout-button",
  component: "TypeButton",
  layout: "match-button",
  mode: "enable",
  text: "timeout",
  showForInsert: true,
  showOn: [
    {
      state: "period.periodStatus",
      value: "inProgress",
      operator: "is",
    },
  ],
  startEvent: true,
  startPlay: true,
  actionGroups: [
    {
      actions: [
        { action: "stopClock", value: "stop", type: "main" },
        {
          action: "nextState",
          value: "timeout",
          type: "primary",
        },
      ],
      conditions: [],
    },
  ],
};

export const Penalty7MeterButton = {
  name: "penalty-7meter-button",
  component: "TypeButton",
  layout: "match-button",
  mode: "enable",
  text: "penalty.7meter",
  showForInsert: true,
  showOn: [
    {
      state: "period.periodStatus",
      value: "inProgress",
      operator: "is",
    },
  ],
  startEvent: true,
  startPlay: true,
  actionGroups: [
    {
      actions: [
        { action: "clearData", value: ["options", "success"], type: "main" },
        { action: "saveData", value: "sevenMetrePenalty", type: "eventType" },
        { action: "saveData", value: "awarded", type: "subType" },
        { action: "sendEvent", value: "new", type: "main" },
        {
          action: "nextState",
          value: "penalty-foul-drawn-player",
          type: "primary",
        },
      ],
      conditions: [],
    },
  ],
};

export const SanctionsButton = {
  name: "sanctions-button",
  component: "TypeButton",
  layout: "match-button",
  mode: "enable",
  text: "sanctions",
  showForInsert: true,
  showOn: [
    { state: "period.periodStatus", value: "inProgress", operator: "is" },
  ],
  actionGroups: [
    {
      actions: [
        { action: "nextState", value: "sanctions-type", type: "primary" },
      ],
      conditions: [],
    },
  ],
};

export const PassivePlayButton = (options) => ({
  name: "passive-play-button",
  component: "TypeButton",
  layout: "match-button wide team passive-play-button",
  mode: "visible",
  text: "passivePlay",
  showOn: [true],
  options,
  actionGroups: [
    {
      actions: [
        { action: "saveData", value: "passivePlay", type: "eventType" },
        { action: "sendEvent", value: "new", type: "main" },
        {
          action: "setPossession",
          value: { currentEntity: false },
          type: "main",
        },
        { action: "nextState", value: null, type: "primary" },
      ],
      conditions: [],
    },
  ],
  startEvent: true,
  startPlay: true,
});
